var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShapeB(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297,
    height: 341,
    viewBox: "0 0 297 341",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.469 203.786V140.597L55.2343 109L1 140.597V203.786L55.2343 235.383L109.469 203.786Z",
    stroke: "#D0556D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M231.469 203.786V140.597L177.234 109L123 140.597V203.786L177.234 235.383L231.469 203.786Z",
    stroke: "#D0556D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M295.469 307.786V244.597L241.234 213L187 244.597V307.786L241.234 339.383L295.469 307.786Z",
    stroke: "#D0556D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.469 96.7861V33.5972L116.234 2L62 33.5972V96.7861L116.234 128.383L170.469 96.7861Z",
    stroke: "#D0556D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M295.469 96.7861V33.5972L241.234 2L187 33.5972V96.7861L241.234 128.383L295.469 96.7861Z",
    stroke: "#D0556D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeB);
export default __webpack_public_path__ + "static/media/shape-b.a39135e8.svg";
export { ForwardRef as ReactComponent };